export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrow-down-e3e93862644abb2d4c939c32d4621d99.svg";